import React from "react";
import "./special_features.css";
import Common_title from "../../common-components/common-title/Common_title";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";

const Special_features = () => {
  return (
    <>
      <section className="Special_features_sec">
        <div className="container">
          <Common_title
            title="SPECIAL FEATURE"
            subtitle="This Makes Us Different"
          />

          <div className="row mt-5">
            <div className="col-md-4 my-auto">
              <div className="imagdiv">
                <img
                  className="mobileimg"
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/home/special-service/moible2.png"
                  }
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="contentdiv">
                <h4 className="gettitle">Exclusive Shopping Deals</h4>
                <p className="withp">Save Big on Top Brands Today</p>

                <div className="feaures-list">
                  <div className="d-flex align-items-center mb-2">
                    <FontAwesomeIcon icon={faCheckCircle} className="inner_icon"/>
                    <p className="mb-0 ms-2">
                      Up to 50% Off Top Selling Products
                    </p>
                  </div>

                  <div className="d-flex align-items-center mb-2">
                    <FontAwesomeIcon icon={faCheckCircle} className="inner_icon"/>
                    <p className="mb-0 ms-2">Free & Fast Express Delivery</p>
                  </div>

                  <div className="d-flex align-items-center mb-2">
                    <FontAwesomeIcon icon={faCheckCircle} className="inner_icon"/>
                    <p className="mb-0 ms-2">Hassle-Free 7-Day Easy Returns</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Special_features;
